module.exports = __webpack_public_path__ + "img/linkedin.f3a56341.svg";